import React from 'react';
import styled from 'styled-components';

import { breakpoints, colors } from '../../constants';

interface IProps {
    hideOnMobile?: boolean;
    style?: React.CSSProperties;
}

export const Wrapper = styled.div<IProps>`
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')}
    height: 100px;

    @media (${breakpoints.mediumMin}) {
        display: block;
        background-color: ${colors.white};
        z-index: 2;
    }
`;
